/*
 * @Author: 孙福聪
 * @Date: 2019-01-16 16:03:16
 * @Last Modified by: 潘磊
 * @Last Modified time: 2019-03-21 18:35:15
 */
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import Case from "./modules/common/csae";
import task from "./modules/common/task";
import doCase from "./modules/student/doCase";
import updateCase from "./modules/teacher/updateCase";
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    Case,
    task,
    doCase,
    updateCase
  },
  plugins: [createPersistedState({ storage: window.sessionStorage })]
});
